import * as Yup from 'yup';

export const MAX_MESSAGE_LENGTH = 500;
export const CHAT_SCHEMA = Yup.object().shape({
  message: Yup.string()
    .min(2, 'Too Short!')
    .max(MAX_MESSAGE_LENGTH, 'Too Long!')
    .required('Required!'),
});
